export default "__VITE_ASSET__B1hjTp_3__"